import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newAddressTemplate", "taxNo", "list"]
  static values = {
    index: { type: Number, default: 0 },
    kind: String
  }

  newAddressTemplate

  connect() {
    if (this.hasNewAddressTemplateTarget) {
      this.newAddressTemplate = this.newAddressTemplateTarget.innerHTML
      this.newAddressTemplate = this.newAddressTemplate.replaceAll(/attributes_country/g, "attributes_$index_country")
      this.newAddressTemplate = this.newAddressTemplate.replaceAll(/attributes\]\[country\]/g, "attributes][$index][country]")
    }
  }

  add() {
    let newAddress = this.newAddressTemplate.replaceAll(/\$index/g, parseInt(this.indexValue))
    newAddress = newAddress.replaceAll(/\$label/g, parseInt(this.indexValue) + 1)
    this.listTarget.insertAdjacentHTML("beforeend", newAddress)
    this.indexValue += 1
  }
}
